<template>
  <el-table :data="controllers" border>
    <el-table-column
        prop="name"
        label="コントローラー名"
        width="200">
      <template #default="{row}">
        <table-inline>
          <text-field-like
              :value="row.name"
              :value-id="row.id">
          </text-field-like>
        </table-inline>
      </template>
    </el-table-column>

    <el-table-column
        prop="description"
        label="説明"
        min-width="200">
      <template #default="{row}">
        <table-inline>
          <text-field-like
              :value="row.description"
              placeholder="未設定"
              multi-line>
          </text-field-like>
        </table-inline>
      </template>
    </el-table-column>

    <el-table-column
        label="登録日"
        prop="createdAt"
        width="100">
      <template #default="{row}">
        {{ formatDate(row.createdAt) }}
      </template>
    </el-table-column>

    <el-table-column
        prop="status"
        label="ステータス"
        width="100">
      <template #default="{row}">
        {{ controllerStatus[row.status] }}
      </template>
    </el-table-column>

    <el-table-column
        prop="pollingRate"
        label="ポーリンク周期"
        width="100">
      <template #header>
        <div style="font-size: 90%;line-height: normal;">ポーリンク<br>周期</div>
      </template>
      <template #default="{row}">
        <table-inline>
          <text-field-like
              :value="row.pollingRate ? `${row.pollingRate} 秒` : null"
              placeholder="未設定">
          </text-field-like>
        </table-inline>
      </template>
    </el-table-column>

    <el-table-column
        width="130"
        align="right"
        fixed="right">
      <template #default="{row}">
        <icon-btns>
          <!-- 編集モード -->
          <template v-if="isEditable">
            <icon-btn
                type="delete"
                @click="openDeleteDialog(row)">
            </icon-btn>
            <icon-btn
                type="edit-content"
                tooltip="名称・説明の編集"
                @click="openUpdateDialog(row)">
            </icon-btn>
            <icon-btn
                type="edit"
                :to="{ name: alterRouteName('./controllers/ControllerShow', 'edit'), params: { controllerId: row.id } }">
            </icon-btn>
          </template>

          <!-- 閲覧モード -->
          <template v-else>
            <icon-btn
                type="view"
                :to="{ name: alterRouteName('./controllers/ControllerShow'), params: { controllerId: row.id } }">
            </icon-btn>
          </template>
        </icon-btns>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import PathInfoMixin from "@/router/PathInfoMixin";
import Formatter from "@/utils/Formatter";
import IconBtn from "@/components/molecules/IconBtn.vue";
import IconBtns from "@/components/molecules/IconBtns";
import {CONTROLLER_STATUSES} from "@/constants";
import TableInline from "@/components/atoms/TableInline.vue";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";

export default {
  name: 'ControllerTable',
  components: {TextFieldLike, TableInline, IconBtns, IconBtn},
  mixins: [
    PathInfoMixin,
    Formatter
  ],
  props: {
    controllers: {
      type: Array,
      required: true
    }
  },
  computed: {
    controllerStatus: () => CONTROLLER_STATUSES,
  },
  methods: {
    openDeleteDialog(row) {
      this.$emit('openDeleteDialog', row)
    },
    openUpdateDialog(row) {
      this.$emit('openUpdateDialog', row)
    }
  }
}
</script>
